import request from '@/utils/request'
// PC未开始任务数-进行中任务数 - 管明杨
export function taskStatistics(params) {
  return request({
    url: '/dataStatistics/taskStatistics',
    method: 'get',
    params
  })
}
// PC今日工单数- 管明杨
export function todayData(params) {
  return request({
    url: '/dataStatistics/todayData',
    method: 'get',
    params
  })
}
// PC待复查工单数- 管明杨
export function reviewedData(params) {
  return request({
    url: '/dataStatistics/reviewedData',
    method: 'get',
    params
  })
}
// PC未处理隐患项- 管明杨
export function untreatedHidden(params) {
  return request({
    url: '/dataStatistics/untreatedHidden',
    method: 'get',
    params
  })
}
// PC待整改隐患项- 管明杨
export function abarbeitungData(params) {
  return request({
    url: '/dataStatistics/abarbeitungData',
    method: 'get',
    params
  })
}
// 执行任务的工单完成情况占比- 管明杨
export function datasStatistics(params) {
  return request({
    url: '/dataStatistics/datasStatistics',
    method: 'get',
    params
  })
}
// PC执行任务中安检员完成率对比- 管明杨
export function inspectorFinishingRate(params) {
  return request({
    url: '/dataStatistics/inspectorFinishingRate',
    method: 'get',
    params
  })
}
// PC安检员今日执行进度- 管明杨
export function inspectorTodaySchedule(params) {
  return request({
    url: '/dataStatistics/inspectorTodaySchedule',
    method: 'get',
    params
  })
}
// PC隐患占比情况(处理状态)- 管明杨
export function hiddenStatus(params) {
  return request({
    url: '/dataStatistics/hiddenStatus',
    method: 'get',
    params
  })
}
// PC隐患占比情况(隐患等级)- 管明杨
export function hiddenLevel(params) {
  return request({
    url: '/dataStatistics/hiddenLevel',
    method: 'get',
    params
  })
}

// BI大屏安检覆盖率
export function fractionCoverage(params) {
  return request({
    url: '/dataStatistics/fractionCoverage',
    method: 'get',
    params
  })
}

// BI大屏执行任务的工单完成情况占比(有未安检)
export function biDatasStatistics(params) {
  return request({
    url: '/dataStatistics/biDatasStatistics',
    method: 'get',
    params
  })
}

// BI大屏
export function biTopValues(params) {
  return request({
    url: '/patrolBoard/biTopValues',
    method: 'get',
    params
  })
}
